var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[_c('el-image',{attrs:{"src":_vm.avatar ? _vm.avatar : 'https://boweisou.oss-cn-shenzhen.aliyuncs.com/admin2.0/orderDefault.png'}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name || '--'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }